import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ButtonContact.module.css';
import { GlobalContext } from '../../GlobalContext';

export default function ButtonContact({value, margin, align}) {
    
    const { scrollToSection, modalIsOpen, setModalIsOpen } = GlobalContext();

    return (
        <Link className={styles.button} 
            to="" 
            style={{marginTop: margin, alignSelf: align}}
            onClick={() => {modalIsOpen && setModalIsOpen(false); scrollToSection('contact')}}>
            {value}
        </Link>
    )
}

